import { oz } from '@weft/utils';
import { InvoiceApprovedNotificationSchema, OverageNotificationSchema } from './notification-schemas';
import { AnonymousCustomerNotificationSchema } from './notification-schemas/anonymous-customer-notification-schema';
import { UpcomingRenewalNotificationSchema } from './notification-schemas/upcoming-renewal-notification-schema';

export const NotificationSchema = oz.discriminatedUnion('eventType', [
  OverageNotificationSchema,
  AnonymousCustomerNotificationSchema,
  UpcomingRenewalNotificationSchema,
  InvoiceApprovedNotificationSchema,
]).openapi('NewNotification');

export type Notification = oz.infer<typeof NotificationSchema>;